// Configuration file for environment variables with defaults

// Google client ID
export const GOOGLE_CLIENT_ID = import.meta.env.GOOGLE_CLIENT_ID || '';

// Function to fetch Google Client ID from the server if not available in the frontend
export const fetchGoogleClientId = async (): Promise<string> => {
    if (GOOGLE_CLIENT_ID) {
        return GOOGLE_CLIENT_ID;
    }

    try {
        console.log('Fetching Google Client ID from server...');
        const response = await fetch('/api/debug-env');
        const data = await response.json();
        return data.google_client_id || '';
    } catch (error) {
        console.error('Error fetching Google Client ID from server:', error);
        return '';
    }
};

// DEPRECATED: ADMIN_USERS environment variable is no longer used.
// Admin status is now determined by backend user.role field.
// Frontend must trust the backend to provide correct role information.
// No local admin allowlist checking is performed in the frontend.
// 
// If you need to set admin users, configure them on the backend side.
export const ADMIN_USERS = import.meta.env.ADMIN_USERS || '';
console.warn('ADMIN_USERS environment variable is deprecated. Admin status is now managed by backend user.role.');

// Demo mode - only true when explicitly set to 'true'
export const DEMO_RUN = import.meta.env.DEMO_RUN === 'true';
